import { render } from "./UserBar.vue?vue&type=template&id=4c411d1e&scoped=true"
import script from "./UserBar.vue?vue&type=script&lang=js"
export * from "./UserBar.vue?vue&type=script&lang=js"

import "./UserBar.vue?vue&type=style&index=0&id=4c411d1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c411d1e"]])

export default __exports__